import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=f0db6122&"
import script from "./Confirmation.vue?vue&type=script&lang=ts&"
export * from "./Confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports